<template>
  <div>
    <div :id="mapId" :style="{ width: w, height: h }"></div>
  </div>
</template>

<script>
import L from "leaflet";
import LocationIconUrl from "@/assets/img/location.svg";

export default {
  name: "GeolacationPicker",
  data() {
    return {
      map: null,
      mapId: "map-" + Math.random() * 1000000000,
      marker: {
        lat: 0,
        lng: 0,
      },
    };
  },
  props: {
    waitModal: {
      type: Boolean,
      default: false,
    },
    w: {
      default: "auto",
      type: String,
    },
    h: String,
    lat: String,
    lng: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    lat() {
      this.initMap();
    },
  },
  mounted() {
    if (this.waitModal) {
      setTimeout(() => {
        this.initMap();
      }, 1);
    } else {
      this.initMap();
    }
  },
  methods: {
    initMap() {
      let container = L.DomUtil.get(this.mapId);
      if (container != null) {
        container._leaflet_id = null;
        L.DomUtil.remove(this.mapId);
      }
      const initialLatLng = this.disabled
        ? [Number(this.lat), Number(this.lng)]
        : [41.299496, 69.240074];

      this.map = L.map(this.mapId).setView(initialLatLng, 14);

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(
        this.map
      );
      // L.tileLayer(
      //   "http://vec{s}.maps.yandex.net/tiles?l=map&v=4.55.2&z={z}&x={x}&y={y}&scale=2&lang=ru_RU",
      //   {
      //     subdomains: ["01", "02", "03", "04"],
      //     attribution: '<a http="yandex.ru" target="_blank">Яндекс</a>',
      //     reuseTiles: true,
      //     updateWhenIdle: false,
      //   }
      // ).addTo(this.map);

      const customIcon = L.icon({
        iconUrl: LocationIconUrl,
        iconSize: [32, 32], // Set the size of your custom icon
        iconAnchor: [16, 32], // Set the anchor point of your custom icon
        popupAnchor: [0, -32], // Set the popup anchor of your custom icon
      });

      const marker = L.marker(initialLatLng, {
        icon: customIcon,
        draggable: !this.disabled,
      }).addTo(this.map);

      if (!this.disabled) {
        marker.on("dragend", (event) => {
          const { lat, lng } = event.target.getLatLng();
          this.marker.lat = lat;
          this.marker.lng = lng;
        });
      }

      if (!this.disabled) {
        this.map.on("click", (event) => {
          const { lat, lng } = event.latlng;
          marker.setLatLng([lat, lng]);
          this.marker.lat = lat;
          this.marker.lng = lng;
          this.$emit("marker-moved", { lat, lng });
        });
      }

      const { lat, lng } = marker.getLatLng();
      this.marker.lat = lat;
      this.marker.lng = lng;
    },
  },
};
</script>
